import { Endpoint } from '../../../../types/questions'
import { EndpointNotification } from './EndpointNotification'

interface Props {
    endpoints: Endpoint[]
    activityAndQuestionCombinationKey: string
}

export const EndpointNotificationList = ({ activityAndQuestionCombinationKey, endpoints }: Props): JSX.Element => {
    if (endpoints.length <= 0) return

    return (
        <>
            {endpoints.map((endpoint) => (
                <EndpointNotification
                    key={endpoint.id}
                    activityAndQuestionCombinationKey={activityAndQuestionCombinationKey}
                    endpoint={endpoint}
                />
            ))}
        </>
    )
}
